import { useEffect, useState } from 'react';
import { getDispatchesForPatient } from '@healthdesk/shared-services';
import { DISPATCH_STATUS } from '../constants/conversationDispatchConstants';

export function usePendingDispatches(patientId) {
  const [dispatches, setDispatches] = useState([]);
  const [loading, setLoading] = useState(Boolean(patientId));
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;

    const load = async () => {
      if (!patientId) {
        setDispatches([]);
        setLoading(false);
        setError(null);
        return;
      }

      setLoading(true);
      setError(null);
      try {
        const rows = await getDispatchesForPatient(patientId, [
          DISPATCH_STATUS.PENDING,
          DISPATCH_STATUS.STARTED,
        ]);
        if (active) {
          setDispatches(rows);
        }
      } catch (err) {
        console.warn('[usePendingDispatches] Failed to load pending dispatches', err);
        if (active) {
          setDispatches([]);
          setError(err);
        }
      } finally {
        if (active) {
          setLoading(false);
        }
      }
    };

    load();
    return () => {
      active = false;
    };
  }, [patientId]);

  return { dispatches, loading, error };
}
